import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslations } from "../../providers/useTranslations";
import { FieldWrapper } from "./FieldWrapper";
export const FormField = forwardRef(({ id, name, render, checkable, validation, error, defaultValue, dataTestId, hasEmptyError, showCustomError = false, labelClassName, ...fieldWrapperProps }, ref) => {
    const { formState: { errors }, control, getValues, } = useFormContext();
    const { __ } = useTranslations();
    const formError = getError(errors, name);
    const fieldId = id || `${name}_control`;
    const errorMessage = formError?.message || error;
    const isRequired = Boolean(validation?.required);
    const isFilled = !!getValues(name);
    const getValidateRule = () => {
        if (validation?.validate) {
            return validation.validate;
        }
        if (isRequired) {
            const requiredErrorMessage = typeof validation?.required === "string" ? validation?.required : __("form_validation.field_required");
            return (value) => (typeof value === "string" ? !!value.trim() || requiredErrorMessage : true);
        }
    };
    return (_jsx(FieldWrapper, { ...fieldWrapperProps, id: fieldId, dataTestId: dataTestId, checkable: checkable, isFilled: isFilled, required: isRequired, error: errorMessage, ref: ref, hasEmptyError: hasEmptyError, showCustomError: showCustomError, labelClassName: labelClassName, children: _jsx(Controller, { render: render, name: name, control: control, rules: { ...validation, validate: getValidateRule() }, defaultValue: defaultValue }) }));
});
const getError = (errors, key) => {
    const keys = key.split(".");
    let error = undefined;
    for (const key of keys) {
        if (!error) {
            error = errors;
        }
        error = error[key];
    }
    return error;
};
//# sourceMappingURL=FormField.js.map